export default __webpack_public_path__ + "static/media/ava-4.224faf0b.png";